export const generateApiUrl = (currency: string, auth?: string) => {
    const baseUrl = process.env.REACT_APP_API_URL;

    if (!baseUrl) {
        throw new Error('Base URL is not defined');
    }

    if (auth === 'pin') {
        return `${baseUrl}pay/${currency}/charge`;
    } else if (auth === 'otp') {
        return `${baseUrl}pay/${currency}/validatepayment`;
    } else if (currency === "KES" && !auth) {
        return `${baseUrl}pay/${currency}/cardpayment/v2`;
    } else if (!auth) {
        return `${baseUrl}pay/${currency}/cardpayment`;
    }

    return `${baseUrl}pay/${currency}/charge`;
};
